import React from 'react';
import { motion } from 'framer-motion';
import { Clock, CheckCircle, AlertTriangle } from 'lucide-react';

interface VideoGenerationStatusProps {
  status: 'pending' | 'processing' | 'completed' | 'failed';
  error?: string;
}

export const VideoGenerationStatus: React.FC<VideoGenerationStatusProps> = ({
  status,
  error
}) => {
  const statusConfig = {
    pending: {
      icon: Clock,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      message: 'Your video is in queue for processing...'
    },
    processing: {
      icon: Clock,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      message: 'Your video is being transformed...'
    },
    completed: {
      icon: CheckCircle,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      message: 'Your magical video is ready!'
    },
    failed: {
      icon: AlertTriangle,
      color: 'text-red-600',
      bgColor: 'bg-red-50',
      message: error || 'Something went wrong during video generation.'
    }
  };

  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`${config.bgColor} rounded-lg p-4 flex items-start space-x-3`}
    >
      <Icon className={`w-5 h-5 ${config.color} flex-shrink-0 mt-0.5`} />
      <div>
        <p className={`font-medium ${config.color}`}>
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </p>
        <p className="text-sm text-gray-600 mt-1">{config.message}</p>
      </div>
    </motion.div>
  );
};